import {createContext} from 'react'

const CalendarioContext = createContext()

export default CalendarioContext